import { DOCOnlineService } from "../../../../services/DOCOnlineService";
import { CommonService } from "../../../../services/CommonService";
export function DocOnlineCtr(props) {
  return {
    getDocOnline() {
      return DOCOnlineService.getDocOnlineById(Number(props.match.params.id))
        .then((data) => {
          return data;
        })
        .catch((err) => console.error(err))
        .finally(() => {});
    },
    saveAs(docOnline) {
      return DOCOnlineService.SaveAsDocOnline(docOnline).then((data) => {
        return data;
      });
    },
    save(docOnline) {
      return DOCOnlineService.EditDocOnline(docOnline).then((data) => {
        return data;
      });
    },
    generateUrl(languageId, companyId, docOnlineId) {
      return DOCOnlineService.generateUrl(
        docOnlineId,
        languageId,
        companyId
      ).then((data) => {
        return data;
      });
    },
    downloadDocOnline(
      templatePrefix,
      languageCode,
      downloadIsInPdf,
      fileName,
      docOnlineId,
      file
    ) {
      return DOCOnlineService.downloadDocOnline(
        docOnlineId,
        templatePrefix,
        languageCode,
        downloadIsInPdf,
        fileName,
        file
      ).then((data) => {
        return data;
      });
    },
    docOnlineService: DOCOnlineService,
    commonService: CommonService
  };
}
